export enum GraphValueType {
  Gross = 'gross',
  Net = 'net',
}
